import Vue from 'vue'
import bus from '../until/eventbus'
import {
    GetFrameByParentId,
    GetUserByParentId,
    GetFrameById,
} from '../until/ZeusApiSDK/Logic/StructureLogic'
import {
    GetSysItemByParentID
} from '../until/ZeusApiSDK/Logic/SysItemLogic'
import {
    getInputData,
    setDetailData,
} from '../until/ZeusApiSDK/Logic/WorkFLowLogic'
//初始化控件
//input 控件参数
//show 是否可编辑
//check 是否必选
//data 控件值
//isfirstStep 是否为第一步
var _fapi

function InitFApi(obj) {
    _fapi = obj
}
async function InitFormRule(input, show, check, data, isfirstStep) {
    var rule = {}
    switch (input.InputType) {
        case 'hidden': //隐藏域
            if (!isfirstStep && show == '0') {
                rule.type = 'hidden'
                rule.sort = input.Sort
                rule.field = input.Field + '_static'
                rule.value = data
            } else {
                rule.type = 'hidden'
                rule.sort = input.Sort
                rule.field = input.Field
                rule.value = data
            }
            break
        case 'label': //标签
            if (!isfirstStep) {
                rule = await GetStaticRule(input, data)
            } else {
                rule.type = 'hidden'
                rule.sort = input.Sort
                rule.field = input.Field
                rule.value = data
            }
            break
        case 'text': //文本框
            if (show == '1') {
                rule.type = 'input'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field
                rule.value = data
                rule.props = {
                    type: 'text',
                    placeholder: '请输入' + input.Name,
                }

                if (input.ValidateType == 'number') {
                    //数字
                    rule.props = {
                        type: 'number',
                        placeholder: '请输入纯数字',
                    }
                }

                if (check == 2) {
                    rule.validate = [{
                        required: true,
                        message: '请输入' + input.Name,
                        trigger: 'blur',
                    },]
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break
        case 'attach': //附件
            if (show == '1') {
                let loading = ''
                rule.type = 'upload'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field
                rule.value = data
                rule.props = {
                    placeholder: '请输入' + input.Name,
                    uploadType: 'file',
                    action: 'http://eapi.ruizhiqi.cn/api/upload/uploadformdata',
                    name: 'pic',
                    format: [
                        'jpg',
                        'jpeg',
                        'png',
                        'gif',
                        'zip',
                        'rar',
                        'xlsx',
                        'xls',
                        'doc',
                        'docx',
                    ],
                    beforeUpload: function (file) {
                        //console.log(file);
                        let imglist = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'];
                        if (file.size > 20971520) {
                            this.$message.error('上传失败,附件过大~（推荐上传大小：小于20M）')
                            return false
                        }
                    },
                    onProgress: function (res, file, fileList) {
                        loading = this.$loading({
                            lock: true,
                            text: '上传中，请稍后....',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.3)'
                        });
                    },
                    onSuccess: function (res, file, fileList) {
                        if (res.Data.Result == 1) {
                            file.url = res.Data.Message
                            loading.close();
                            this.$message({
                                message: '上传完成',
                                type: 'success'
                            });
                        } else {
                            loading.close();
                            this.$message.error('上传失败,请查看文件是否过大~')
                        }
                    },
                    onError: function (res, file, fileList) {
                        loading.close();
                        this.$message.error('上传失败,请稍后再试~')
                    },
                }
                if (check == 2) {
                    rule.validate = [{
                        required: true,
                        message: '请上传' + input.Name,
                        trigger: 'change',
                    },]
                }
            } else {
                rule = await GetStaticAttachRule(input, data)
            }
            break
        case 'checkbox': //复选框
            if (show == '1') {
                data = SplitData(data)
                rule.type = 'checkbox'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field
                rule.value = data
                rule.options = GetOptions(input)
                if (check) {
                    rule.validate = [{
                        type: 'array',
                        min: 1,
                        required: true,
                        message: '最少选择1个',
                        trigger: 'blur',
                    },]
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break
        case 'select': //下拉选框
            if (show == '1') {
                data = SplitData(data)
                rule.type = 'select'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field
                rule.value = data
                rule.props = {
                    clearable: true,
                    filterable: true,
                }
                rule.options = GetOptions(input)
                if (check == 2) {
                    rule.validate = [{
                        required: true,
                        message: '请输入' + input.Name,
                        trigger: 'blur',
                    },]
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break
        case 'radio': //单选框
            if (show == '1') {
                data = SplitData(data)
                rule.type = 'radio'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field
                rule.value = data
                rule.options = GetOptions(input)
                if (check == 2) {
                    rule.validate = [{
                        required: true,
                        message: '请输入' + input.Name,
                        trigger: 'blur',
                    },]
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break
        case 'datetime': //日期时间选择
            if (show == '1') {
                rule.type = 'DatePicker'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field
                rule.value = data
                rule.props = {
                    type: 'datetime',
                    format: input.Field == 'StartTime' ? 'yyyy-MM-dd HH:30:00' : input.Field == 'EndTime' ? 'yyyy-MM-dd HH:00:00' : 'yyyy-MM-dd HH:mm:00',
                    placeholder: '请输入' + input.Name,
                    editable: false,
                    align: 'left',
                    defaultTime: input.Field == 'StartTime' ? '08:30:00' : input.Field == 'EndTime' ? '18:00:00' : '',
                }
                if (check == 2) {
                    rule.validate = [{
                        required: true,
                        message: '请输入' + input.Name,
                        trigger: 'blur',
                    },]
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break
        case 'date': //日期选择
            if (show == '1') {
                rule.type = 'DatePicker'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field
                rule.value = data
                rule.props = {
                    type: 'date',
                    format: 'yyyy-MM-dd',
                    placeholder: '请输入' + input.Name,
                    editable: false,
                    align: 'left',
                }
                if (check == 2) {
                    rule.validate = [{
                        required: true,
                        message: '请输入' + input.Name,
                        trigger: 'blur',
                    },]
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break
        case 'textarea': //文本域
            //console.log(show);
            if (show == '1') {
                //console.log("show");
                rule.type = 'input'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field
                rule.value = data
                rule.props = {
                    type: 'textarea',
                    placeholder: '请输入' + input.Name,
                }
                if (check == 2) {
                    rule.validate = [{
                        required: true,
                        message: '请输入' + input.Name,
                        trigger: 'blur',
                    },]
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break

        case 'selectmember': //选择人员
            if (show == '1') {
                rule.type = 'input'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field + '_input'
                rule.value = data
                if (check == 2) {
                    rule.validate = [{
                        required: true,
                        message: '请选择' + input.Name,
                        trigger: 'blur',
                    },]
                }
                rule.on = {
                    focus: function () {
                        bus.$emit('showSelectMemberDialog', input.Field)
                    },
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break
        // case "selectframe": //选择部门
        //   if (show == "1") {
        //     rule.type = "cascader";
        //     rule.title = input.Name;
        //     rule.field = input.Field;
        //     rule.value = data;
        //     rule.props = {
        //       props: {
        //         lazy: true,
        //         checkStrictly: true,
        //         lazyLoad: (node, resolve) => {
        //           GetFrameByParentId(node.value).then((res) => {
        //             if (res.length > 0) {
        //               var nodes = [];
        //               res.forEach((element) => {
        //                 var node = {
        //                   value: element.Id,
        //                   label: element.ClassName,
        //                   leaf: false,
        //                 };
        //                 nodes.push(node);
        //               });
        //               resolve(nodes);
        //             } else {
        //               resolve([]);
        //             }
        //           });
        //         },
        //       },
        //     };
        //   } else {
        //     rule = await GetStaticRule(input, data);
        //   }
        //   break;
        case 'selectframe': //选择部门
            if (show == '1') {
                rule.type = 'input'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field + '_input'
                rule.value = data
                rule.on = {
                    focus: function () {
                        bus.$emit('showSelectFrameDialog', input.Field)
                    },
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break
        case 'cascade': //级联选择
            if (show == '1') {
                rule.type = 'select'
                rule.sort = input.Sort
                rule.title = input.Name
                rule.field = input.Field
                rule.value = data
                rule.options = GetOptions(input)
                rule.props = {
                    clearable: true,
                    filterable: true,
                }
                rule.on = {
                    change: async function (val) {
                        var opts = []
                        if (val) {
                            if (input.DictionaryType == '3') {
                                _fapi.model()[
                                    input.CascadeField
                                ].options = await GetFramesOptionByParentId(val)
                            } else if (input.DictionaryType == '2') {
                                var list = await GetSysItemByParentID(val)
                                var options = []
                                for (let l of list) {
                                    options.push({
                                        label: l.ClassName,
                                        value: l.Id,
                                    })
                                }
                                _fapi.model()[
                                    input.CascadeField
                                ].options = options
                            }
                        } else {
                            _fapi.model()[input.CascadeField].options = opts
                        }
                    },
                }
                if (check == 2) {
                    rule.validate = [{
                        required: true,
                        message: '请选择' + input.Name,
                        trigger: 'blur',
                    },]
                }
            } else {
                rule = await GetStaticRule(input, data)
            }
            break
        case 'detail': //明细表单
            //console.log(input, show, check, data);
            if (show == '1') {
                rule.type = 'group'
                rule.sort = input.Sort
                rule.field = input.Field
                rule.title = input.Name
                rule.value = []
                var detailInput = eval(input.DetailValue)
                var detailData = SplitData(data)

                var detailRules = []
                if (detailInput instanceof Array) {
                    //console.log(detailInput)
                    detailInput.forEach(async (element) => {
                        var d = detailData.filter(
                            (p) => p.field == element.Field
                        )
                        var dv = ''
                        if (d.length > 0) {
                            dv = d[0].value
                        }
                        var r = await InitFormRule(element, show, 0, dv, false)
                        detailRules.push(r)
                    })
                }
                rule.props = {
                    rules: detailRules,
                }
                //console.log(rule)
            } else {
                rule = await GetStaticDetailRule(input, data)
            }
            break
        default:
            break
    }
    return rule
}
async function GetStaticRule(input, data) {
    var rule = {}
    rule.type = 'template'
    rule.name = 'label'
    rule.title = input.Name
    rule.sort = input.Sort
    if (input.InputType == 'selectframe' || input.InputType == 'selectmember') {
        rule.field = input.Field + '_input'
    } else {
        rule.field = input.Field + '_static'
    }
    rule.template =
        '<div style="text-align:left;margin-top:10px;"><span>{{v}}</span></div>'
    rule.value = await getInputData(input, data)
    rule.vm = new Vue({
        data: {
            v: await getInputData(input, data),
        },
    })
    return rule
}
//注意事项
function GetAttentionRule(data) {
    var rule = {}
    rule.type = 'template'
    rule.name = 'attention'
    rule.title = '注意事项'
    rule.field = 'attention'
    rule.template =
        '<ol class="attention"><li v-for="(item,index) in attention" :key="index">{{item}}</li></ol>'
    rule.vm = new Vue({
        data: {
            attention: data,
        },
    })
    return rule
}
async function GetStaticDetailRule(input, data) {
    //console.log(input);
    var rule = {}
    rule.type = 'template'
    rule.name = input.Field
    rule.title = input.Name
    rule.field = input.Field
    rule.value = data
    rule.template =
        '<div ><ul v-for="(v,vindex) in details" :key="vindex" style="list-style:none;padding-left:5px;text-align:left;"><li v-for="(dv) in v" :key="dv.field">{{dv.name}}:{{dv.value}}</li></ul></div>'
    rule.vm = new Vue({
        data: {
            details: await setDetailData(input, data),
        },
    })
    return rule
}
async function GetStaticAttachRule(input, data) {
    var rule = {}
    rule.type = 'template'
    rule.name = input.Field
    rule.title = input.Name
    rule.field = input.Field + '_static'
    rule.template =
        '<div><div v-for="(img,index) in attachs" :key="index">' +
        '<el-image v-if="\'jpg|gif|png|jpeg\'.indexOf(img.substring(img.lastIndexOf(\'.\')+1))>=0" style="width: 50px; height: 50px" :src="img" :preview-src-list="attachs"></el-image>' +
        '<a style="color:#ddd;font-size:20px" v-if="\'jpg|gif|png|jpeg\'.indexOf(img.substring(img.lastIndexOf(\'.\')+1))<0" :href="img"><i class="el-icon-document"></i></a></div></div>'
    rule.vm = new Vue({
        data: {
            attachs: await getInputData(input, data),
        },
    })
    return rule
}

function GetStepTimeLinesRule(data) {
    var rule = {}
    rule.type = 'template'
    rule.name = 'stepTimeLine'
    rule.title = '审核流程'
    rule.field = 'stepTimeLine'
    rule.template =
        // '<el-steps style="margin-top:10px" finish-status="success" direction="vertical"><el-step :status="statusFormatter(item)" v-for="(item,index) in timeLines" :key="index" :title="item.Name" :description="item.Handler+\'(\'+item.ResultMessage+\')\'+item.CompletedTime" ></el-step></el-steps>';
        '<el-steps style="margin-top:10px" finish-status="success" direction="vertical"><el-step :status="statusFormatter(item)" v-for="(item,index) in timeLines" :key="index" :title="item.Name" description="item.Handler" ><template slot="description" ><span>{{item.Handler+\'(\'+item.ResultMessage+\')\'}}<br/>{{item.CompletedTime}}</span></template></el-step></el-steps>'
    rule.vm = new Vue({
        data: {
            timeLines: data,
        },
        methods: {
            statusFormatter: function (item) {
                var status = 'wait'
                switch (item.Result) {
                    case 0:
                        status = 'wait'
                        break
                    case 1:
                        status = 'process'
                        break
                    case 2:
                        status = 'success'
                        break
                    case 3:
                        status = 'error'
                        break
                    case 4:
                        status = 'success'
                        break
                }
                return status
            },
        },
    })
    return rule
}
//获取选项
function GetOptions(input) {
    //console.log(input.DictionaryType);
    var options = []

    if (input.DictionaryType == '1') {
        var arr = input.DictionaryValue.split(';')
        // console.log(arr);
        if (arr.length > 0) {
            arr.forEach((element) => {
                var elarr = element.split(',')
                var option = elarr.length > 1 ? {
                    value: elarr[0],
                    label: elarr[1],
                    disabled: false,
                } : {
                    value: elarr[0],
                    label: elarr[0],
                    disabled: false,
                }
                options.push(option)
            })
        }
        return options
    } else if (input.DictionaryType == '2') {
        return GetItemByParentID(input.DictionaryValue)
    } else if (
        input.DictionaryType == '3' &&
        input.DictionaryValue == 'company'
    ) {
        return GetFramesOptionByParentId('')
    }
}
//根据父级ID获取系统字典选项
function GetItemByParentID(parentId) {
    var options = []
    GetSysItemByParentID(parentId).then((res) => {
        if (res != null) {
            res.forEach((element) => {
                var option = {
                    value: element.Id,
                    label: element.ClassName,
                    disabled: false,
                }
                options.push(option)
            })
        }
    })
    return options
}
//根据父级ID获取子部门选项
function GetFramesOptionByParentId(parentId) {
    var options = []
    GetFrameById(parentId).then((res) => {
        if (res != null) {
            res.forEach((element) => {
                var option = {
                    value: element.Id,
                    label: element.ClassName,
                    disabled: false,
                }
                options.push(option)
            })
        }
    })
    GetFrameByParentId(parentId).then((res) => {
        if (res != null) {
            res.forEach((element) => {
                var option = {
                    value: element.Id,
                    label: element.ClassName,
                    disabled: false,
                }
                options.push(option)
            })
        }
    })
    return options
}

function SplitData(data) {
    var arr = []
    if (data) {
        arr = data.split(',')
    }
    return arr
}
export {
    InitFormRule,
    InitFApi,
    GetAttentionRule,
    GetStepTimeLinesRule
}